import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import WhatsAppEmbeddedSignupJobStatusResponse from "../model/WhatsAppEmbeddedSignupJobStatusResponse";
import { HttpClientError } from "../../../../providers/HttpClient";

const SIGNUP_TIMEOUT_DURATION = 60 * 5000; // 5 minutes

// Helper function to check if we're within the signup timeout period (5 minutes)
const isWithinSignupTimeout = (signupAttemptTime: number | null): boolean => {
  if (!signupAttemptTime) return false;
  return Date.now() - signupAttemptTime < SIGNUP_TIMEOUT_DURATION;
};

const WhatsAppEmbeddedSignupJobStatusApiService =
  async (): Promise<WhatsAppEmbeddedSignupJobStatusResponse> => {
    const url = "/whatsapp_embedded_signup_jobs/latest_for_employer/";

    try {
      const { data } = await axios.get(url, {
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
      });
      return data;
    } catch (error) {
      const axiosError = error as AxiosError;
      const errorMessage = HttpClientError(axiosError);
      const customError = new Error(errorMessage);

      customError.cause = axiosError;
      throw customError;
    }
  };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useWhatsAppEmbeddedSignupJobStatusApiService = (
  ignoreTimeoutSignupAttempt: number | null = null,
  enabled = true
) =>
  useQuery<WhatsAppEmbeddedSignupJobStatusResponse | null, AxiosError>(
    ["WhatsAppEmbeddedSignupJobStatusApiService", ignoreTimeoutSignupAttempt],
    () => WhatsAppEmbeddedSignupJobStatusApiService(),
    {
      enabled,
      keepPreviousData: false,
      retry: false,
      retryOnMount: true,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      staleTime: 0,
      refetchOnMount: "always",
      refetchInterval: isWithinSignupTimeout(ignoreTimeoutSignupAttempt)
        ? 2000
        : false, // Poll every 2 seconds during timeout period
    }
  );

export {
  WhatsAppEmbeddedSignupJobStatusApiService,
  useWhatsAppEmbeddedSignupJobStatusApiService,
  SIGNUP_TIMEOUT_DURATION,
  isWithinSignupTimeout,
};
